export class PageScroll {
  static lock = () => (window.document.documentElement.style.overflow = 'hidden')
  static unlock = () => (window.document.documentElement.style.overflow = 'initial')
}

export default PageScroll
